'use client';

import { useLocale, useTranslations } from 'next-intl';
import { useRouter, usePathname } from '@/i18n/navigation';
import { routing, type Locale } from '@/i18n/routing';

export function LocaleToggle() {
  const current = useLocale() as Locale;
  const router = useRouter();
  const pathname = usePathname();
  const t = useTranslations('LocaleToggle');
  const headerT = useTranslations('Header');

  return (
    <div role="group" aria-label={headerT('localeAriaLabel')} className="flex gap-1">
      {routing.locales.map((locale) => {
        const isActive = locale === current;
        return (
          <button
            key={locale}
            type="button"
            aria-pressed={isActive}
            onClick={() => router.replace(pathname, { locale })}
            className={`px-2 py-1 text-xs uppercase tracking-widest ${
              isActive ? 'text-(--color-accent)' : 'text-(--color-muted-foreground)'
            }`}
          >
            {t(locale)}
          </button>
        );
      })}
    </div>
  );
}
